"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var isArrayLike_1 = require("@kurtosys/ksys-app-template/dist/utils/isArrayLike");
// eslint-disable-next-line @typescript-eslint/naming-convention
var Query = ksys_app_template_1.query.Query;
var QueryContext = /** @class */ (function () {
    function QueryContext(configuration, seed) {
        this.configuration = configuration;
        this.seed = seed;
    }
    QueryContext.prototype.fetch = function (client, inputs, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var response, configuration, batchPromises;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = {};
                        configuration = this.orchestrateConfiguration(this.configuration, inputs);
                        batchPromises = __spreadArrays(this.getEntityPromises(response, client, configuration, inputs, culture), this.getCommentaryPromises(response, client, configuration), this.getDisclaimerPromises(response, client, configuration), this.getDocumentPromises(response, client, configuration), this.getFundListPromises(response, client, configuration), this.getClientConfigurationPromises(response, client, configuration), this.getUserConfigurationPromises(response, client, configuration), this.getScenarioPromises(response, client, configuration, inputs), this.getScenarioReportPromises(response, client, configuration, inputs), this.getLearningPromises(response, client, configuration, inputs), this.getLoggedInUserPromises(response, client, configuration, inputs), this.getGlobalSearchPromises(response, client, configuration, inputs));
                        return [4 /*yield*/, ksys_app_template_1.utils.promise.batchExecutePromises(batchPromises)];
                    case 1:
                        _a.sent();
                        response.isPerformanceAllowed = this.getPerformanceAllowed(response);
                        response.globalQueries = this.configuration.globalQueries;
                        // These can rely on the previously fetched information so they need to stay here
                        return [4 /*yield*/, this.loadPortfolio(response, client, configuration, inputs)];
                    case 2:
                        // These can rely on the previously fetched information so they need to stay here
                        _a.sent();
                        return [4 /*yield*/, this.loadPortfolioEntity(response, client, configuration, inputs)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getEntitiesPromises(response, client, configuration, inputs, culture)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getDatasetPromises(response, client, configuration, inputs, culture)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    QueryContext.prototype.orchestrateConfiguration = function (configuration, inputs) {
        if (inputs === void 0) { inputs = {}; }
        // If there are multiple inputs then we would rather convert everything to a string once,
        // then replace it as a string search to avoid racking up the call stack
        try {
            var configurationString = JSON.stringify(configuration);
            for (var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++) {
                var key = _a[_i];
                var inputKey = "{input:" + key + "}";
                var inputValue = inputs[key];
                // If we try to join with undefined we are getting a "," returned
                if (ksys_app_template_1.utils.typeChecks.isUndefined(inputValue)) {
                    inputValue = '';
                }
                configurationString = configurationString.split(inputKey).join(inputValue);
            }
            var response = JSON.parse(configurationString);
            return response;
        }
        catch (ex) {
            // If the conversions fail for any reason we can do a deep recursion
            // This can fail if the configuration for some reason has a circular dependency, of the
            // input value is invalid when replacing into the string
            console.warn('orchestrateConfiguration: string replacement failed, moving to recursive', ex);
        }
        var workingConfiguration = ksys_app_template_1.utils.object.deepMergeObjects({}, configuration);
        for (var _b = 0, _c = Object.keys(inputs); _b < _c.length; _b++) {
            var key = _c[_b];
            var inputKey = "{input:" + key + "}";
            var inputValue = inputs[key];
            // If we try to join with undefined we are getting a "," returned
            if (ksys_app_template_1.utils.typeChecks.isUndefined(inputValue)) {
                inputValue = '';
            }
            ksys_app_template_1.utils.replaceTextRecursive(workingConfiguration, inputKey, inputValue);
        }
        return workingConfiguration;
    };
    QueryContext.prototype.getPerformanceAllowed = function (response) {
        var performanceCheck = this.configuration.performanceCheck;
        if (performanceCheck) {
            var startQueryOptions = performanceCheck.start, endQueryOptions = performanceCheck.end, useNowForEndDate = performanceCheck.useNowForEndDate, measure = performanceCheck.measure;
            if (measure && startQueryOptions && (endQueryOptions || useNowForEndDate)) {
                var operator = measure.operator, period = measure.period, expectedValue = measure.value;
                var executionOptions = {
                    context: response,
                };
                var startQuery = new Query(startQueryOptions);
                var startDateRaw = startQuery.execute(executionOptions);
                var endDateRaw = void 0;
                if (useNowForEndDate) {
                    endDateRaw = new Date().toUTCString();
                }
                else {
                    var endQuery = new Query(endQueryOptions);
                    endDateRaw = endQuery.execute(executionOptions);
                }
                var dateDifference = ksys_app_template_1.utils.date.getDateDifference(endDateRaw, startDateRaw, period);
                var permissionAllowed = false;
                switch (operator) {
                    case '>':
                        permissionAllowed = dateDifference > expectedValue;
                        break;
                    case '>=':
                        permissionAllowed = dateDifference >= expectedValue;
                        break;
                    default:
                        break;
                }
                return permissionAllowed;
            }
        }
        // If no performance check is provided allow performance values
        return true;
    };
    QueryContext.prototype.getEntityPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.entityByType) {
            // Has a seed value for the request
            response.entityByType = {};
            var _loop_1 = function (entityType) {
                var entityTypeSeedValue = this_1.seed.entityByType[entityType];
                batchPromises.push({
                    identifier: { entityType: entityType },
                    promiseFunc: function () { return entityTypeSeedValue; },
                    responseFunc: function (promiseResponse, identifier) {
                        response.entityByType[identifier.entityType] = promiseResponse;
                    },
                });
            };
            var this_1 = this;
            for (var _i = 0, _a = Object.keys(this.seed.entityByType); _i < _a.length; _i++) {
                var entityType = _a[_i];
                _loop_1(entityType);
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getEntityPromises = function (response, client, configuration, inputs, culture) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getEntityPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var entityByType = configuration.entityByType;
            if (entityByType) {
                response.entityByType = {};
                var _loop_2 = function (entityType) {
                    var entityTypeConfiguration = entityByType[entityType];
                    batchPromises.push({
                        identifier: { entityType: entityType },
                        promiseFunc: function () {
                            return _this.fetchEntityForType(client, inputs, entityType, entityTypeConfiguration, culture);
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            response.entityByType[identifier.entityType] = promiseResponse;
                        },
                    });
                };
                for (var _i = 0, _a = Object.keys(entityByType); _i < _a.length; _i++) {
                    var entityType = _a[_i];
                    _loop_2(entityType);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getEntitiesPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.entities) {
            // Has a seed value for the request
            response.entities = {};
            var _loop_3 = function (entityKey) {
                var entitiesSeedValue = this_2.seed.entities[entityKey];
                batchPromises.push({
                    identifier: { entityKey: entityKey },
                    promiseFunc: function () { return entitiesSeedValue; },
                    responseFunc: function (promiseResponse, identifier) {
                        response.entities[identifier.entityKey] = promiseResponse;
                    },
                });
            };
            var this_2 = this;
            for (var _i = 0, _a = Object.keys(this.seed.entities); _i < _a.length; _i++) {
                var entityKey = _a[_i];
                _loop_3(entityKey);
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getEntitiesPromises = function (response, client, configuration, inputs, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var batchPromises, entities, fetchOnInitializeEntities_2, entitiesWithLinks, links_1, duplicateLinks, initializedEntityLinkedReferences, _i, fetchOnInitializeEntities_1, entity;
            return __generator(this, function (_a) {
                batchPromises = __spreadArrays(this.getEntitiesPromisesFromSeed(response));
                // If there are batch promises from the seed then don't try to fetch information
                if (batchPromises.length === 0) {
                    entities = configuration.entities;
                    if (entities) {
                        response.entities = {};
                        fetchOnInitializeEntities_2 = entities.filter(function (entity) { return entity.fetchOnInitialize; });
                        entitiesWithLinks = entities.filter(function (entity) { var _a; return ((_a = entity.linkedEntities) === null || _a === void 0 ? void 0 : _a.length) > 0; });
                        if ((entitiesWithLinks === null || entitiesWithLinks === void 0 ? void 0 : entitiesWithLinks.length) > 0) {
                            links_1 = ksys_app_template_1.utils.collection.flatDeep(entitiesWithLinks
                                .map(function (entityWithLinks) { return entityWithLinks.linkedEntities
                                .map(function (linkedEntity) { return linkedEntity.targetId; }); }), Infinity);
                            duplicateLinks = links_1.filter(function (item, index) { return links_1.indexOf(item) !== index; });
                            if ((duplicateLinks === null || duplicateLinks === void 0 ? void 0 : duplicateLinks.length) > 0) {
                                console.error("CONFIGURATION ERROR: Target Ids (" + duplicateLinks.join(', ') + ") are duplicated in Linked Entities. Please update the configuration.");
                            }
                            initializedEntityLinkedReferences = links_1.reduce(function (references, link) {
                                if (fetchOnInitializeEntities_2.findIndex(function (entity) { return entity.id === link; }) > -1) {
                                    references.push(link);
                                }
                                return references;
                            }, []);
                            if ((initializedEntityLinkedReferences === null || initializedEntityLinkedReferences === void 0 ? void 0 : initializedEntityLinkedReferences.length) > 0) {
                                console.error("CONFIGURATION ERROR: Target Ids (" + initializedEntityLinkedReferences.join(', ') + ") are referencing fetchOnInitialize entities. Please update the configuration.");
                            }
                        }
                        // Only adds the entities that are configured to be fetched on initialize.
                        for (_i = 0, fetchOnInitializeEntities_1 = fetchOnInitializeEntities_2; _i < fetchOnInitializeEntities_1.length; _i++) {
                            entity = fetchOnInitializeEntities_1[_i];
                            batchPromises.push(this.getEntitiesBatchPromises(entity, response, client, configuration, inputs, culture));
                        }
                    }
                }
                return [2 /*return*/, ksys_app_template_1.utils.promise.batchExecutePromises(batchPromises)];
            });
        });
    };
    QueryContext.prototype.getEntitiesBatchPromises = function (entity, response, client, configuration, inputs, culture, linkedEntityConfig) {
        var _this = this;
        return {
            identifier: { entityKey: entity.id },
            promiseFunc: function () {
                return _this.fetchEntities(client, entity.id, inputs, configuration, {
                    inputs: inputs,
                    culture: culture && culture.targetCulture,
                    context: response,
                });
            },
            responseFunc: function (promiseResponse, identifier) { return __awaiter(_this, void 0, void 0, function () {
                var batchPromises, _loop_4, this_3, _i, _a, linkedEntity;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // Set the response.entities at the top of the function to prevent circular referencing of the linked entities. 
                            // Checks are in place to prevent a linked entity from firing again if there is already a response.
                            response.entities[identifier.entityKey] = promiseResponse;
                            this.applyEntityMapToLinkedEntities(response, linkedEntityConfig, identifier.entityKey, promiseResponse);
                            if (!entity.linkedEntities) return [3 /*break*/, 2];
                            batchPromises = [];
                            _loop_4 = function (linkedEntity) {
                                // Don't fire if the entity already has a promise. Avoid circular referencing. 
                                var hasExistingResponse = response.entities[linkedEntity.targetId];
                                if (!hasExistingResponse) {
                                    var entities = configuration.entities;
                                    // find the associated linkedEntity IQueryContextEntity
                                    var childEntity = entities.find(function (e) { return e.id === linkedEntity.targetId; });
                                    this_3.orchestrateLinkedEntitySearch(childEntity, linkedEntity, promiseResponse);
                                    // Create query to set the search prop and call self. Sets up batch for current list of linked entities.
                                    // Parent entity has already resolved.
                                    batchPromises.push(this_3.getEntitiesBatchPromises(childEntity, response, client, configuration, inputs, culture, Object.assign(linkedEntity, { sourceId: identifier.entityKey })));
                                }
                            };
                            this_3 = this;
                            for (_i = 0, _a = entity.linkedEntities; _i < _a.length; _i++) {
                                linkedEntity = _a[_i];
                                _loop_4(linkedEntity);
                            }
                            return [4 /*yield*/, ksys_app_template_1.utils.promise.batchExecutePromises(batchPromises)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); },
        };
    };
    QueryContext.prototype.applyEntityMapToLinkedEntities = function (response, linkedEntityParentConfig, entityKey, promiseResponse) {
        // If the parent had linked entities, determine which child entities belong to it and add it to its entity map
        if (linkedEntityParentConfig) {
            // The current batch of entities
            var entities = response.entities[entityKey];
            var parentEntityKey = linkedEntityParentConfig.sourceId;
            // The parent entities that these entites might have a relation with
            var parentEntities = response.entities[parentEntityKey];
            // Ensure that there are entities to work on
            if (parentEntities.total > 0 && entities.total > 0) {
                var sourceIdentifierType = linkedEntityParentConfig.sourceIdentifierType, sourceProperty = linkedEntityParentConfig.sourceProperty, targetIdentifierType = linkedEntityParentConfig.targetIdentifierType, targetProperty = linkedEntityParentConfig.targetProperty;
                for (var _i = 0, _a = parentEntities.values; _i < _a.length; _i++) {
                    var parentEntity = _a[_i];
                    // Source Identifier will hold the value from the parent that the entities should match based on the property that links them up
                    var sourceIdentifierValue = this.resolveLinkedEntitesConfigurationValues(parentEntity, sourceIdentifierType, sourceProperty);
                    for (var _b = 0, _c = entities.values; _b < _c.length; _b++) {
                        var childEntity = _c[_b];
                        // Target Identifier will be the value from the entity that the source should match 
                        var targetIdentifierValue = this.resolveLinkedEntitesConfigurationValues(childEntity, targetIdentifierType, targetProperty);
                        // need to handle cardinality n values
                        if (this.identifiersMatch(targetIdentifierValue, sourceIdentifierValue)) {
                            // First ensure the mapping keys are setup
                            this.setupMappingKeysForEntities(parentEntities);
                            this.setupMappingKeysForEntities(entities);
                            // Then populate them
                            this.populateEntitiesMaps(parentEntities, childEntity, parentEntity.entityId, entityKey);
                            this.populateEntitiesMaps(entities, parentEntity, childEntity.entityId, parentEntityKey);
                        }
                    }
                }
            }
        }
    };
    QueryContext.prototype.identifiersMatch = function (targetIdentifier, sourceIdentifier) {
        if (isArrayLike_1.isArrayLike(targetIdentifier) && !isArrayLike_1.isArrayLike(sourceIdentifier)) {
            return targetIdentifier.includes(sourceIdentifier);
        }
        if (isArrayLike_1.isArrayLike(sourceIdentifier) && !isArrayLike_1.isArrayLike(targetIdentifier)) {
            return sourceIdentifier.includes(targetIdentifier);
        }
        if (isArrayLike_1.isArrayLike(targetIdentifier) && isArrayLike_1.isArrayLike(sourceIdentifier)) {
            return targetIdentifier.some(function (value) { return sourceIdentifier.includes(value); });
        }
        if (!isArrayLike_1.isArrayLike(targetIdentifier) && !isArrayLike_1.isArrayLike(sourceIdentifier)) {
            return targetIdentifier === sourceIdentifier;
        }
        console.warn("identifiersMatch: Returned false for target value: " + targetIdentifier + " & source value: " + sourceIdentifier);
        return false;
    };
    QueryContext.prototype.populateEntitiesMaps = function (targetEntities, linkedEntity, targetEntityId, entityKey) {
        var _a;
        // Populate the entitiesById
        var parentEntitiesById = targetEntities.entitiesById;
        // If the ById map does not have the entity in the map add it
        if (!parentEntitiesById.has(linkedEntity.entityId)) {
            parentEntitiesById.set(linkedEntity.entityId, linkedEntity);
        }
        // Populate the entityMap
        var targetEntitiesMap = targetEntities.entityMap;
        if (targetEntitiesMap) {
            if (!targetEntitiesMap.has(targetEntityId)) {
                targetEntitiesMap.set(targetEntityId, {});
            }
            var entityMap = targetEntitiesMap.get(targetEntityId);
            if (!entityMap[entityKey]) {
                targetEntitiesMap.set(targetEntityId, __assign(__assign({}, entityMap), (_a = {}, _a[entityKey] = new Set(), _a)));
            }
            targetEntitiesMap.get(targetEntityId)[entityKey].add(linkedEntity.entityId);
        }
    };
    QueryContext.prototype.setupMappingKeysForEntities = function (entities) {
        if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(entities.entitiesById)) {
            entities.entitiesById = new Map();
        }
        if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(entities.entityMap)) {
            entities.entityMap = new Map();
        }
    };
    QueryContext.prototype.resolveLinkedEntitesConfigurationValues = function (entity, type, property) {
        if (type === 'clientCode') {
            return entity.clientCode;
        }
        return entity.properties_pub[property] && entity.properties_pub[property].value;
    };
    QueryContext.prototype.orchestrateLinkedEntitySearch = function (entity, linkedEntity, response) {
        var sourceIdentifierType = linkedEntity.sourceIdentifierType, sourceProperty = linkedEntity.sourceProperty, targetIdentifierType = linkedEntity.targetIdentifierType, targetProperty = linkedEntity.targetProperty;
        var values = response.values;
        var requestBody = entity.requestBody;
        var search = requestBody.search;
        var responseValues = values === null || values === void 0 ? void 0 : values.reduce(function (responseValues, value) {
            var _a;
            if (sourceIdentifierType === 'clientCode') {
                responseValues.push(value.clientCode);
                return responseValues;
            }
            var propertyValue = (_a = value.properties_pub[sourceProperty]) === null || _a === void 0 ? void 0 : _a.value;
            if (sourceIdentifierType === 'property' && propertyValue) {
                if (Array.isArray(propertyValue)) {
                    responseValues.push.apply(responseValues, propertyValue);
                }
                else {
                    responseValues.push(propertyValue);
                }
            }
            return responseValues;
        }, []);
        // Remove duplicates to clean up the search values
        var uniqueResponseValues = responseValues.filter(function (c, index) { return responseValues.indexOf(c) === index; });
        var property = targetIdentifierType === 'property' ? targetProperty : 'clientCode';
        // Find existing search target property to append values if the existing is matchtype is MATCH to avoid any weird edge cases.   
        var targetIndex = search.findIndex(function (searchItem) {
            return searchItem.property === property && searchItem.matchtype === 'MATCH';
        });
        if (targetIndex > -1) {
            search[targetIndex].values.push(uniqueResponseValues);
        }
        else {
            search.push({
                property: property,
                matchtype: 'MATCH',
                values: uniqueResponseValues,
            });
        }
    };
    QueryContext.prototype.getScenarioPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.scenario) {
            // Has a seed value for the request
            var scenarioSeedValue_1 = this.seed.scenario;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return scenarioSeedValue_1; },
                responseFunc: function (promiseResponse) {
                    response.scenario = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getScenarioPromises = function (response, client, configuration, inputs) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getScenarioPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var scenario_1 = configuration.scenario;
            if (scenario_1) {
                batchPromises.push({
                    identifier: {},
                    promiseFunc: function () { return _this.fetchScenario(client, inputs, scenario_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && promiseResponse.value) {
                            response.scenario = promiseResponse.value;
                        }
                    },
                });
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getScenarioReportPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.scenarioReport) {
            // Has a seed value for the request
            var scenarioReportSeedValue_1 = this.seed.scenarioReport;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return scenarioReportSeedValue_1; },
                responseFunc: function (promiseResponse) {
                    response.scenarioReport = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getLearningPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.article) {
            // Has a seed value for the request
            var articleSeedValue_1 = this.seed.article;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return articleSeedValue_1; },
                responseFunc: function (promiseResponse) {
                    response.article = promiseResponse;
                },
            });
        }
        if (this.seed && this.seed.courses) {
            // Has a seed value for the request
            var coursesSeedValue_1 = this.seed.courses;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return coursesSeedValue_1; },
                responseFunc: function (promiseResponse) {
                    response.courses = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getGlobalSearchPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.wordpressGlobalSearch) {
            // Has a seed value for the request
            var articleSeedValue_2 = this.seed.wordpressGlobalSearch;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return articleSeedValue_2; },
                responseFunc: function (promiseResponse) {
                    response.wordpressGlobalSearch = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getLoggedInUserPromisesFromSeed = function (response) {
        var batchPromises = [];
        if (this.seed && this.seed.loggedInUser) {
            // Has a seed value for the request
            var loggedInUserSeedValue_1 = this.seed.loggedInUser;
            batchPromises.push({
                identifier: {},
                promiseFunc: function () { return loggedInUserSeedValue_1; },
                responseFunc: function (promiseResponse) {
                    response.loggedInUser = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getScenarioReportPromises = function (response, client, configuration, inputs) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getScenarioReportPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var scenarioReport_1 = configuration.scenarioReport;
            if (scenarioReport_1) {
                batchPromises.push({
                    identifier: {},
                    promiseFunc: function () { return _this.fetchScenarioReport(client, inputs, scenarioReport_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && promiseResponse.value) {
                            response.scenarioReport = promiseResponse.value;
                        }
                    },
                });
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getLearningPromises = function (response, client, configuration, inputs) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getLearningPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var learning_1 = configuration.learning;
            if (learning_1) {
                batchPromises.push({
                    identifier: {},
                    promiseFunc: function () { return _this.fetchArticle(client, inputs, learning_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && promiseResponse.value) {
                            response.article = promiseResponse.value;
                        }
                    },
                }, {
                    identifier: {},
                    promiseFunc: function () { return _this.fetchCourses(client, inputs, learning_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && promiseResponse.courses) {
                            response.courses = promiseResponse.courses;
                        }
                    },
                });
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getGlobalSearchPromises = function (response, client, configuration, inputs) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getGlobalSearchPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var wordpressGlobalSearch_1 = configuration.wordpressGlobalSearch;
            if (wordpressGlobalSearch_1) {
                batchPromises.push({
                    identifier: {},
                    promiseFunc: function () { return _this.fetchWordpressGlobalSearchContent(client, inputs, wordpressGlobalSearch_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && promiseResponse.value) {
                            response.wordpressGlobalSearch = promiseResponse.value;
                        }
                    },
                });
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getLoggedInUserPromises = function (response, client, configuration, inputs) {
        var _this = this;
        var batchPromises = __spreadArrays(this.getLoggedInUserPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var loggedInUser_1 = configuration.loggedInUser;
            if (loggedInUser_1) {
                batchPromises.push({
                    identifier: {},
                    promiseFunc: function () { return _this.fetchLoggedInUser(client, inputs, loggedInUser_1); },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse) {
                            response.loggedInUser = promiseResponse;
                        }
                    },
                });
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.loadPortfolioFromSeed = function (response) {
        var hasSeedValue = false;
        if (this.seed && this.seed.portfolio) {
            // Has a seed value for the request
            response.portfolio = this.seed.portfolio;
            hasSeedValue = true;
        }
        return hasSeedValue;
    };
    QueryContext.prototype.loadPortfolio = function (response, client, configuration, inputs) {
        return __awaiter(this, void 0, void 0, function () {
            var hasSeedValue, portfolioConfiguration, portfolios, idQuery, id_1, portfolio, promiseResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasSeedValue = this.loadPortfolioFromSeed(response);
                        if (!!hasSeedValue) return [3 /*break*/, 2];
                        portfolioConfiguration = configuration.portfolio;
                        if (!portfolioConfiguration) return [3 /*break*/, 2];
                        if (response && response.scenario) {
                            portfolios = response.scenario.portfolios;
                            if (portfolios) {
                                idQuery = new Query(portfolioConfiguration.id);
                                id_1 = idQuery.execute({ inputs: inputs });
                                portfolio = portfolios.find(function (portfolio) { return _this.idEqual(id_1, portfolio.portfolioId); });
                                if (portfolio) {
                                    response.portfolio = portfolio;
                                }
                                return [2 /*return*/];
                            }
                        }
                        return [4 /*yield*/, this.fetchPortfolio(client, inputs, portfolioConfiguration)];
                    case 1:
                        promiseResponse = _a.sent();
                        if (promiseResponse && promiseResponse.value) {
                            response.portfolio = promiseResponse.value;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.idEqual = function (id, existingId) {
        if (typeof id === 'string') {
            return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(existingId) && id === existingId.toString();
        }
        return id === existingId;
    };
    QueryContext.prototype.loadPortfolioEntityFromSeed = function (response) {
        var hasSeedValue = false;
        if (this.seed && this.seed.portfolioEntity) {
            // Has a seed value for the request
            response.portfolioEntity = this.seed.portfolioEntity;
            hasSeedValue = true;
        }
        return hasSeedValue;
    };
    QueryContext.prototype.loadPortfolioEntity = function (response, client, configuration, inputs) {
        return __awaiter(this, void 0, void 0, function () {
            var hasSeedValue, portfolioEntityConfiguation, entities, idQuery, id_2, portfolioEntity, promiseResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasSeedValue = this.loadPortfolioEntityFromSeed(response);
                        if (!hasSeedValue) return [3 /*break*/, 2];
                        portfolioEntityConfiguation = configuration.portfolioEntity;
                        if (!portfolioEntityConfiguation) return [3 /*break*/, 2];
                        if (response && response.portfolio) {
                            entities = response.portfolio.entities;
                            if (entities) {
                                idQuery = new Query(portfolioEntityConfiguation.id);
                                id_2 = idQuery.execute({ inputs: inputs });
                                portfolioEntity = entities.find(function (portfolioEntity) {
                                    return _this.idEqual(id_2, portfolioEntity.portfolioEntityId);
                                });
                                if (portfolioEntity) {
                                    response.portfolioEntity = portfolioEntity;
                                }
                                return [2 /*return*/];
                            }
                        }
                        return [4 /*yield*/, this.fetchPortfolioEntity(client, inputs, portfolioEntityConfiguation)];
                    case 1:
                        promiseResponse = _a.sent();
                        if (promiseResponse && promiseResponse.value) {
                            response.portfolioEntity = promiseResponse.value;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.getDocumentPromises = function (response, client, configuration) {
        var collectionKey = 'globalDocuments';
        var batchPromises = __spreadArrays(this.getCollectionPromisesFromSeed(response, collectionKey));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var collection = configuration[collectionKey];
            var previousDocumentsById_1 = {};
            if (collection && Array.isArray(collection)) {
                var _loop_5 = function (documentQuery) {
                    batchPromises.push({
                        identifier: collectionKey,
                        promiseFunc: function () {
                            return client.documents.search.execute({ body: documentQuery });
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            var _a;
                            if (promiseResponse) {
                                if (promiseResponse.entities) {
                                    response.documentEntities = promiseResponse.entities;
                                }
                                if (promiseResponse.joinMap) {
                                    response.documentJoinMap = promiseResponse.joinMap;
                                }
                                if (!response[identifier]) {
                                    response[identifier] = [];
                                }
                                if (promiseResponse && promiseResponse.values) {
                                    var documents = promiseResponse.values;
                                    var uniqueDocuments = documents.filter(function (document) { return !previousDocumentsById_1[document.clientCode]; });
                                    uniqueDocuments.forEach(function (document) {
                                        var clientCode = document.clientCode;
                                        previousDocumentsById_1[clientCode] = true;
                                    });
                                    (_a = response[identifier]).push.apply(_a, uniqueDocuments);
                                }
                            }
                        },
                    });
                };
                for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
                    var documentQuery = collection_1[_i];
                    _loop_5(documentQuery);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.orchestrateSearchDocumentResponse = function (searchDocumentResponse, queryContext) {
        var _a;
        if (searchDocumentResponse) {
            if (searchDocumentResponse.entities) {
                if (!queryContext.documentEntities) {
                    queryContext.documentEntities = {};
                }
                queryContext.documentEntities = __assign(__assign({}, queryContext.documentEntities), searchDocumentResponse.entities);
            }
            if (searchDocumentResponse.joinMap) {
                if (!queryContext.documentJoinMap) {
                    queryContext.documentJoinMap = {};
                }
                queryContext.documentJoinMap = __assign(__assign({}, queryContext.documentJoinMap), searchDocumentResponse.joinMap);
            }
            if (!queryContext['globalDocuments']) {
                queryContext['globalDocuments'] = [];
            }
            if (searchDocumentResponse && searchDocumentResponse.values) {
                var documents = searchDocumentResponse.values;
                var existingDocuments_1 = queryContext['globalDocuments'];
                var uniqueDocuments = documents.filter(function (document) { return !existingDocuments_1.some(function (doc) { return doc.clientCode === document.clientCode; }); });
                (_a = queryContext['globalDocuments']).push.apply(_a, uniqueDocuments);
            }
        }
        return queryContext;
    };
    QueryContext.prototype.getCollectionPromisesFromSeed = function (response, collectionKey) {
        var batchPromises = [];
        var collection = this.seed && this.seed[collectionKey];
        if (collection) {
            batchPromises.push({
                identifier: collectionKey,
                promiseFunc: function () { return collection; },
                responseFunc: function (promiseResponse, identifier) {
                    var _a;
                    if (promiseResponse) {
                        if (!response[identifier]) {
                            response[identifier] = [];
                        }
                        (_a = response[identifier]).push.apply(_a, promiseResponse);
                    }
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getCommentaryPromises = function (response, client, configuration) {
        var collectionKey = 'globalCommentaries';
        var batchPromises = __spreadArrays(this.getCollectionPromisesFromSeed(response, collectionKey));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var collection = configuration[collectionKey];
            if (collection && Array.isArray(collection)) {
                var _loop_6 = function (contentItemQuery) {
                    var cultures = contentItemQuery.cultures, global_1 = contentItemQuery.global, types = contentItemQuery.types;
                    batchPromises.push({
                        identifier: collectionKey,
                        promiseFunc: function () {
                            var body = {};
                            if (types && types.length > 0) {
                                body.commentaryType = types;
                            }
                            if (cultures && cultures.length > 0) {
                                body.culture = cultures;
                            }
                            if (typeof global_1 === 'boolean') {
                                body.global = global_1;
                            }
                            return client.commentaries.list.execute({ body: body });
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            var _a;
                            if (promiseResponse) {
                                if (!response[identifier]) {
                                    response[identifier] = [];
                                }
                                (_a = response[identifier]).push.apply(_a, promiseResponse);
                            }
                        },
                    });
                };
                for (var _i = 0, collection_2 = collection; _i < collection_2.length; _i++) {
                    var contentItemQuery = collection_2[_i];
                    _loop_6(contentItemQuery);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getDisclaimerPromises = function (response, client, configuration) {
        var collectionKey = 'globalDisclaimers';
        var batchPromises = __spreadArrays(this.getCollectionPromisesFromSeed(response, collectionKey));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var collection = configuration[collectionKey];
            if (collection && Array.isArray(collection)) {
                var _loop_7 = function (contentItemQuery) {
                    var cultures = contentItemQuery.cultures, global_2 = contentItemQuery.global, types = contentItemQuery.types;
                    batchPromises.push({
                        identifier: collectionKey,
                        promiseFunc: function () {
                            var body = {};
                            if (types && types.length > 0) {
                                body.disclaimerType = types;
                            }
                            if (cultures && cultures.length > 0) {
                                body.culture = cultures;
                            }
                            if (typeof global_2 === 'boolean') {
                                body.global = global_2;
                            }
                            return client.disclaimers.list.execute({ body: body });
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            var _a;
                            if (promiseResponse) {
                                if (!response[identifier]) {
                                    response[identifier] = [];
                                }
                                (_a = response[identifier]).push.apply(_a, promiseResponse);
                            }
                        },
                    });
                };
                for (var _i = 0, collection_3 = collection; _i < collection_3.length; _i++) {
                    var contentItemQuery = collection_3[_i];
                    _loop_7(contentItemQuery);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getFundListPromisesFromSeed = function (response) {
        var _this = this;
        var batchPromises = [];
        if (this.seed && this.seed.fundListMapping) {
            batchPromises.push({
                identifier: 'fundLists',
                promiseFunc: function () { return _this.seed.fundListMapping; },
                responseFunc: function (promiseResponse) {
                    response.fundListMapping = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getFundListPromises = function (response, client, configuration) {
        var batchPromises = __spreadArrays(this.getFundListPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var options_1 = configuration.fundLists;
            if (options_1 &&
                options_1.lists &&
                Array.isArray(options_1.lists) &&
                options_1.lists.length > 0 &&
                client &&
                client.fundLists &&
                client.fundLists.list) {
                var batchPromise = {
                    identifier: 'fundLists',
                    promiseFunc: function () {
                        var body = {};
                        var lists = options_1.lists;
                        if (lists) {
                            body.listName = lists;
                        }
                        return client.fundLists.list.execute({ body: body });
                    },
                    responseFunc: function (promiseResponse) {
                        if (promiseResponse && Array.isArray(promiseResponse)) {
                            var fundLists = {};
                            for (var _i = 0, promiseResponse_1 = promiseResponse; _i < promiseResponse_1.length; _i++) {
                                var fundListBody = promiseResponse_1[_i];
                                var listName = fundListBody.listName, funds = fundListBody.funds;
                                if (!fundLists[listName]) {
                                    fundLists[listName] = {};
                                }
                                if (funds && funds.length > 0) {
                                    for (var _a = 0, funds_1 = funds; _a < funds_1.length; _a++) {
                                        var fund = funds_1[_a];
                                        if (typeof fund === 'string') {
                                            fundLists[listName][fund] = true;
                                        }
                                        else {
                                            fundLists[listName][fund.clientCode] = true;
                                        }
                                    }
                                }
                            }
                            response.fundListMapping = fundLists;
                        }
                    },
                };
                batchPromises.push(batchPromise);
            }
        }
        return batchPromises;
    };
    //
    QueryContext.prototype.getDatasetPromisesFromSeed = function (response) {
        var _this = this;
        var batchPromises = [];
        if (this.seed && this.seed.datasets) {
            batchPromises.push({
                identifier: 'dataset',
                promiseFunc: function () { return _this.seed.fundListMapping; },
                responseFunc: function (promiseResponse) {
                    response.datasets = promiseResponse;
                },
            });
        }
        return batchPromises;
    };
    QueryContext.prototype.getDatasetPromises = function (response, client, configuration, inputs, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var batchPromises, datasets, _i, datasets_1, dataset;
            return __generator(this, function (_a) {
                batchPromises = __spreadArrays(this.getDatasetPromisesFromSeed(response));
                // If there are batch promises from the seed then don't try to fetch information
                if (batchPromises.length === 0) {
                    datasets = configuration.datasets;
                    if (datasets) {
                        response.datasets = {};
                        for (_i = 0, datasets_1 = datasets; _i < datasets_1.length; _i++) {
                            dataset = datasets_1[_i];
                            // only process dataset requests that are flagged to be fetched when the application initializes
                            if (dataset.fetchOnInitialize) {
                                batchPromises.push(this.getDatasetsBatchPromises(dataset, response, client, inputs, culture));
                            }
                        }
                    }
                }
                return [2 /*return*/, ksys_app_template_1.utils.promise.batchExecutePromises(batchPromises)];
            });
        });
    };
    QueryContext.prototype.getDatasetsBatchPromises = function (dataset, response, client, inputs, culture) {
        var _this = this;
        var datasetKey = dataset.datasetKey;
        var executionOptions = {
            inputs: inputs,
            culture: culture && culture.targetCulture,
            context: response,
        };
        return {
            identifier: datasetKey,
            promiseFunc: function () {
                return _this.fetchDataset(client, dataset, executionOptions);
            },
            responseFunc: function (promiseResponse, identifier) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    response.datasets[identifier] = promiseResponse.value;
                    return [2 /*return*/];
                });
            }); },
        };
    };
    QueryContext.prototype.getClientConfigurationPromisesFromSeed = function (response) {
        var batchPromises = [];
        var clientConfigurations = this.seed && this.seed.clientConfigurations;
        if (clientConfigurations) {
            var _loop_8 = function (code) {
                batchPromises.push({
                    identifier: code,
                    promiseFunc: function () { return clientConfigurations[code]; },
                    responseFunc: function (promiseResponse, identifier) {
                        response.clientConfigurations[identifier] = promiseResponse.value;
                    },
                });
            };
            for (var _i = 0, _a = Object.keys(clientConfigurations); _i < _a.length; _i++) {
                var code = _a[_i];
                _loop_8(code);
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getClientConfigurationPromises = function (response, client, configuration) {
        var batchPromises = __spreadArrays(this.getClientConfigurationPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var clientConfigurations = configuration.clientConfigurations;
            if (clientConfigurations && clientConfigurations.length > 0) {
                var prefix_1 = 'clientConfiguration|';
                var _loop_9 = function (code) {
                    var batchPromise = {
                        identifier: "" + prefix_1 + code,
                        promiseFunc: function () {
                            var body = {
                                code: code,
                            };
                            return client.config.clientConfiguration.retrieve.execute({ body: body });
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            if (promiseResponse && identifier.startsWith(prefix_1)) {
                                if (!response.clientConfigurations) {
                                    response.clientConfigurations = {};
                                }
                                var code_1 = identifier.substr(prefix_1.length);
                                response.clientConfigurations[code_1] = promiseResponse;
                            }
                        },
                    };
                    batchPromises.push(batchPromise);
                };
                for (var _i = 0, clientConfigurations_1 = clientConfigurations; _i < clientConfigurations_1.length; _i++) {
                    var code = clientConfigurations_1[_i];
                    _loop_9(code);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getUserConfigurationPromisesFromSeed = function (response) {
        var batchPromises = [];
        var userConfigurations = this.seed && this.seed.userConfigurations;
        if (userConfigurations) {
            var _loop_10 = function (code) {
                batchPromises.push({
                    identifier: code,
                    promiseFunc: function () { return userConfigurations[code]; },
                    responseFunc: function (promiseResponse, identifier) {
                        response.userConfigurations[identifier] = promiseResponse;
                    },
                });
            };
            for (var _i = 0, _a = Object.keys(userConfigurations); _i < _a.length; _i++) {
                var code = _a[_i];
                _loop_10(code);
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.getUserConfigurationPromises = function (response, client, configuration) {
        var batchPromises = __spreadArrays(this.getUserConfigurationPromisesFromSeed(response));
        // If there are batch promises from the seed then don't try to fetch information
        if (batchPromises.length === 0) {
            var userConfigurations = configuration.userConfigurations;
            if (userConfigurations && userConfigurations.length > 0) {
                var prefix_2 = 'userConfiguration|';
                var _loop_11 = function (code) {
                    var batchPromise = {
                        identifier: "" + prefix_2 + code,
                        promiseFunc: function () {
                            var body = {
                                code: code,
                            };
                            return client.config.userConfiguration.retrieve.execute({ body: body });
                        },
                        responseFunc: function (promiseResponse, identifier) {
                            if (promiseResponse && identifier.startsWith(prefix_2)) {
                                if (!response.userConfigurations) {
                                    response.userConfigurations = {};
                                }
                                var code_2 = identifier.substr(prefix_2.length);
                                response.userConfigurations[code_2] = promiseResponse;
                            }
                        },
                    };
                    batchPromises.push(batchPromise);
                };
                for (var _i = 0, userConfigurations_1 = userConfigurations; _i < userConfigurations_1.length; _i++) {
                    var code = userConfigurations_1[_i];
                    _loop_11(code);
                }
            }
        }
        return batchPromises;
    };
    QueryContext.prototype.fetchEntityForType = function (client, inputs, entityType, entityTypeConfiguration, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var entitiesResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!entityTypeConfiguration) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchEntitiesForType(client, inputs, entityType, entityTypeConfiguration, culture)];
                    case 1:
                        entitiesResponse = _a.sent();
                        if (entitiesResponse && entitiesResponse.values && entitiesResponse.values.length > 0) {
                            return [2 /*return*/, entitiesResponse.values[0]];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.fetchEntitiesForType = function (client, inputs, entityType, entityTypeConfiguration, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var inputKey, clientCodeProperty, explicitInclude, _a, searchEntityRequest, _b, searchEntityRequestOptions, savedSearchEntity, fetchOptions, clientCode, include, workingSearch, _c, searchMergeType, search, mergeOptions, merged, translationOptions, sourceCulture, targetCulture, requestBody, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!entityTypeConfiguration) return [3 /*break*/, 4];
                        inputKey = entityTypeConfiguration.inputKey, clientCodeProperty = entityTypeConfiguration.clientCodeProperty, explicitInclude = entityTypeConfiguration.include, _a = entityTypeConfiguration.searchEntityRequest, searchEntityRequest = _a === void 0 ? {} : _a, _b = entityTypeConfiguration.searchEntityRequestOptions, searchEntityRequestOptions = _b === void 0 ? {} : _b, savedSearchEntity = entityTypeConfiguration.savedSearchEntity, fetchOptions = entityTypeConfiguration.fetchOptions;
                        if (!savedSearchEntity) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchSavedSearchEntity(client, savedSearchEntity, inputs, culture)];
                    case 1: return [2 /*return*/, _d.sent()];
                    case 2:
                        clientCode = inputs[inputKey] || '';
                        if (!ksys_app_template_1.utils.typeChecks.isNullOrWhitespace(inputKey) && ksys_app_template_1.utils.typeChecks.isNullOrWhitespace(clientCode)) {
                            return [2 /*return*/];
                        }
                        include = explicitInclude || searchEntityRequest.include || {};
                        workingSearch = searchEntityRequest.search;
                        if (clientCodeProperty && inputKey) {
                            _c = searchEntityRequestOptions.searchMergeType, searchMergeType = _c === void 0 ? 'replaceValues' : _c;
                            search = [
                                {
                                    property: clientCodeProperty,
                                    matchtype: 'MATCH',
                                    values: [clientCode],
                                },
                            ];
                            if (searchMergeType === 'keepValues') {
                                mergeOptions = {
                                    arrayMergeStrategy: 'DeepMergeByKeyOrAppend',
                                    getKeyFn: function (item) { return item.property || item; },
                                };
                                merged = ksys_app_template_1.utils.object.deepMergeObjectsWithOptions(mergeOptions, { search: workingSearch }, { search: search });
                                if (merged && merged.search) {
                                    workingSearch = merged.search;
                                }
                            }
                            else {
                                workingSearch = search;
                            }
                        }
                        translationOptions = {};
                        if (culture) {
                            sourceCulture = culture.sourceCulture, targetCulture = culture.targetCulture;
                            if (sourceCulture && targetCulture) {
                                translationOptions = {
                                    sourceCulture: sourceCulture,
                                    culture: targetCulture,
                                    translate: true,
                                };
                            }
                        }
                        requestBody = this.cleanSearchEntityRequestBody(__assign(__assign(__assign(__assign({}, translationOptions), {
                            type: entityType,
                        }), searchEntityRequest), {
                            include: include,
                            search: workingSearch,
                        }), inputs, fetchOptions);
                        return [4 /*yield*/, client.entity.search.execute({
                                baseUrl: client.options.baseUrl,
                                body: requestBody,
                            })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, response];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.fetchEntities = function (client, id, staticInputs, configuration, executionOptions, overrideFetchOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, entities, queryContextEntity, workingQueryContextEntity, fetchOptions, staticEntityOverride, _b, staticEntityOverrideType, mergeOptions, _c, inputQueryList, requestBody, requestBodyQueries, savedSearchEntity, inputQueryKeyValue, dynamicInputs, inputs, workingRequestBody, queryResults, cleanRequestBody, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = configuration.entities, entities = _a === void 0 ? [] : _a;
                        queryContextEntity = entities.find(function (entity) { return entity.id === id; });
                        if (!queryContextEntity) return [3 /*break*/, 4];
                        workingQueryContextEntity = queryContextEntity;
                        fetchOptions = ksys_app_template_1.utils.object.deepMergeObjects({}, workingQueryContextEntity.fetchOptions || {}, overrideFetchOptions);
                        if (fetchOptions) {
                            staticEntityOverride = fetchOptions.staticEntityOverride, _b = fetchOptions.staticEntityOverrideArrayType, staticEntityOverrideType = _b === void 0 ? 'keepValues' : _b;
                            if (staticEntityOverride) {
                                mergeOptions = void 0;
                                if (staticEntityOverrideType === 'replaceValues') {
                                    mergeOptions = { arrayMergeStrategy: 'DeepMerge' };
                                }
                                else {
                                    mergeOptions = {
                                        arrayMergeStrategy: 'DeepMergeByKeyOrAppend',
                                        getKeyFn: function (item) { return item.property || item; },
                                    };
                                }
                                workingQueryContextEntity = ksys_app_template_1.utils.object.deepMergeObjectsWithOptions(mergeOptions, workingQueryContextEntity, staticEntityOverride);
                            }
                        }
                        _c = workingQueryContextEntity.inputs, inputQueryList = _c === void 0 ? [] : _c, requestBody = workingQueryContextEntity.requestBody, requestBodyQueries = workingQueryContextEntity.requestBodyQueries, savedSearchEntity = workingQueryContextEntity.savedSearchEntity;
                        inputQueryKeyValue = inputQueryList.reduce(function (inputQueries, inputQuery) {
                            if (!inputQueries[inputQuery.key]) {
                                inputQueries[inputQuery.key] = inputQuery.query;
                            }
                            return inputQueries;
                        }, {});
                        dynamicInputs = Query.convertQueryKeyValue(inputQueryKeyValue, executionOptions);
                        inputs = ksys_app_template_1.utils.object.deepMergeObjects(staticInputs || {}, dynamicInputs || {});
                        if (!savedSearchEntity) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchSavedSearchEntity(client, savedSearchEntity, inputs)];
                    case 1: return [2 /*return*/, _d.sent()];
                    case 2:
                        workingRequestBody = requestBody || {};
                        if (requestBodyQueries) {
                            queryResults = Query.convertQueryMime(requestBodyQueries, executionOptions);
                            workingRequestBody = ksys_app_template_1.utils.object.deepMergeObjects(requestBody || {}, queryResults);
                        }
                        cleanRequestBody = this.cleanSearchEntityRequestBody(workingRequestBody, inputs, fetchOptions);
                        return [4 /*yield*/, client.entity.search.execute({
                                baseUrl: client.options.baseUrl,
                                body: cleanRequestBody,
                            })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, response];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.cleanSearchEntityRequestBody = function (body, inputs, fetchOptions) {
        var response = QueryContext.replaceInputs(body, inputs);
        if (response.search) {
            if (fetchOptions) {
                var _a = fetchOptions.search, searchOptions = _a === void 0 ? {} : _a;
                var _b = searchOptions.strip, strip = _b === void 0 ? {} : _b;
                if (strip.blankStrings) {
                    response.search.forEach(function (search) {
                        search.values = search.values.filter(function (value) { return value !== ''; });
                    });
                }
                if (strip.undefinedValues) {
                    response.search.forEach(function (search) {
                        search.values = search.values.filter(function (value) { return !ksys_app_template_1.utils.typeChecks.isUndefined(value); });
                    });
                }
                if (strip.nullValues) {
                    response.search.forEach(function (search) {
                        search.values = search.values.filter(function (value) { return value !== null; });
                    });
                }
                if (strip.emptyValuesArrays) {
                    response.search = response.search.filter(function (search) { return search.values && search.values.length > 0; });
                }
            }
        }
        return response;
    };
    QueryContext.prototype.fetchSavedSearchEntity = function (client, configuration, inputs, culture) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString, sourceCulture, targetCulture, _i, _a, input, savedSearchInputKey, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryString = {};
                        if (culture) {
                            sourceCulture = culture.sourceCulture, targetCulture = culture.targetCulture;
                            if (sourceCulture && targetCulture) {
                                queryString['sourceCulture'] = sourceCulture;
                                queryString['culture'] = targetCulture;
                            }
                        }
                        for (_i = 0, _a = configuration.inputs; _i < _a.length; _i++) {
                            input = _a[_i];
                            savedSearchInputKey = input.savedSearchInputKey || input.appInputKey;
                            queryString[savedSearchInputKey] = inputs[input.appInputKey];
                        }
                        return [4 /*yield*/, client.entity.savedSearchEntity.execute({
                                queryString: queryString,
                                urlParams: [configuration.key],
                                method: 'GET',
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    QueryContext.prototype.fetchScenarios = function (client, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var limit, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.scenario && client.scenario.list)) return [3 /*break*/, 2];
                        limit = (configuration && configuration.limit) || 10;
                        return [4 /*yield*/, client.scenario.list.execute({
                                body: {
                                    paging: {
                                        limit: limit,
                                    },
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing scenario or scenario.list',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchScenarioReports = function (client, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var limit, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.scenarioReport && client.scenarioReport.list)) return [3 /*break*/, 2];
                        limit = (configuration && configuration.limit) || 10;
                        return [4 /*yield*/, client.scenarioReport.list.execute({
                                body: {
                                    paging: {
                                        limit: limit,
                                    },
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing scenario report or scenarioReport.list',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchDataset = function (client, configuration, executionOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var datasetKey, _a, rawRequestConfig, _b, method, inputsConfig, rawRequest, request, inputQueryKeyValue, inputs, response, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        datasetKey = configuration.datasetKey, _a = configuration.request, rawRequestConfig = _a === void 0 ? {} : _a, _b = configuration.method, method = _b === void 0 ? 'GET' : _b;
                        if (!client.datasets) return [3 /*break*/, 4];
                        inputsConfig = rawRequestConfig.inputs, rawRequest = __rest(rawRequestConfig, ["inputs"]);
                        request = __assign({ code: datasetKey }, rawRequest);
                        // convert request input queries into a key value object
                        if (inputsConfig) {
                            inputQueryKeyValue = inputsConfig.reduce(function (inputQueries, inputQuery) {
                                if (!inputQueries[inputQuery.key]) {
                                    inputQueries[inputQuery.key] = inputQuery.query;
                                }
                                return inputQueries;
                            }, {});
                            inputs = Query.convertQueryKeyValue(inputQueryKeyValue, executionOptions);
                            request.inputs = inputs;
                        }
                        if (!(method === 'GET' && client.datasets.executeGet)) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.datasets.executeGet.execute({
                                queryString: request.inputs,
                                urlParams: [request.code],
                            })];
                    case 1:
                        response = _c.sent();
                        return [2 /*return*/, response];
                    case 2:
                        if (!(method === 'POST' && client.datasets.execute)) return [3 /*break*/, 4];
                        return [4 /*yield*/, client.datasets.execute.execute({
                                body: __assign({}, request),
                            })];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, response];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.getQueryStringForPortfolioBaseRequest = function (configuration) {
        var entityInclude = configuration.entityInclude, riskEntity = configuration.riskEntity, entitySort = configuration.entitySort, correlationIndicesOptions = configuration.correlationIndicesOptions;
        var queryString;
        if (entityInclude || riskEntity || entitySort) {
            queryString = {};
            if (entityInclude) {
                queryString.entityInclude = JSON.stringify(entityInclude);
            }
            if (riskEntity) {
                queryString.riskEntity = JSON.stringify(riskEntity);
            }
            if (entitySort) {
                queryString.entitySort = JSON.stringify(entitySort);
            }
            if (correlationIndicesOptions) {
                queryString.correlationIndicesOptions = JSON.stringify(correlationIndicesOptions);
            }
        }
        return queryString;
    };
    QueryContext.prototype.fetchScenario = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var idQuery, id, queryString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.scenario && client.scenario.get && configuration.id)) return [3 /*break*/, 2];
                        idQuery = new Query(configuration.id);
                        id = idQuery.execute({ inputs: inputs });
                        queryString = this.getQueryStringForPortfolioBaseRequest(configuration);
                        return [4 /*yield*/, client.scenario.get.execute({
                                queryString: queryString,
                                urlParams: [id],
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing scenario or scenario.get or id in configuration',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchScenarioReport = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var idQuery, id, queryString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.scenarioReport && client.scenarioReport.get && configuration.id)) return [3 /*break*/, 2];
                        idQuery = new Query(configuration.id);
                        id = idQuery.execute({ inputs: inputs });
                        queryString = this.getQueryStringForPortfolioBaseRequest(configuration);
                        return [4 /*yield*/, client.scenarioReport.get.execute({
                                queryString: queryString,
                                urlParams: [id],
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing scenario report or scenarioReport.get or id in configuration',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchPortfolio = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var idQuery, id, queryString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.portfolio && client.portfolio.get && configuration.id)) return [3 /*break*/, 2];
                        idQuery = new Query(configuration.id);
                        id = idQuery.execute({ inputs: inputs });
                        queryString = this.getQueryStringForPortfolioBaseRequest(configuration);
                        return [4 /*yield*/, client.portfolio.get.execute({
                                queryString: queryString,
                                urlParams: [id],
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing portfolio or portfolio.get or id in configuration',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchPortfolioEntity = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var idQuery, id, queryString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.portfolioEntity && client.portfolioEntity.get && configuration.id)) return [3 /*break*/, 2];
                        idQuery = new Query(configuration.id);
                        id = idQuery.execute({ inputs: inputs });
                        queryString = this.getQueryStringForPortfolioBaseRequest(configuration);
                        return [4 /*yield*/, client.portfolioEntity.get.execute({
                                queryString: queryString,
                                urlParams: [id],
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/, {
                            valid: false,
                            errorCode: ksys_app_template_1.models.portal.ErrorCode.exceptionCaught,
                            error: 'Client missing portfolioEntity or portfolioEntity.get or id in configuration',
                        }];
                }
            });
        });
    };
    QueryContext.prototype.fetchArticle = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var idQuery, id, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.learning && client.learning.getArticle && configuration.article && configuration.article.id)) return [3 /*break*/, 2];
                        idQuery = new Query(configuration.article.id);
                        id = idQuery.execute({ inputs: inputs });
                        return [4 /*yield*/, client.learning.getArticle.execute({
                                body: {
                                    id: id,
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.fetchCourses = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.learning && client.learning.listMyCourses && configuration.courses)) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.learning.listMyCourses.execute({
                                method: 'GET',
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.fetchWordpressGlobalSearchContent = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.websites && client.websites.globalSearch && configuration.request)) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.websites.globalSearch.execute({
                                method: 'GET',
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.prototype.fetchLoggedInUser = function (client, inputs, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.auth && client.auth.getUserByToken && configuration)) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.auth.getUserByToken.execute()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    QueryContext.replaceInputs = function (instance, inputs, keyPrefix) {
        if (keyPrefix === void 0) { keyPrefix = 'input'; }
        // If there are multiple inputs then we would rather convert everything to a string once,
        // then replace it as a string search to avoid racking up the call stack
        try {
            var instanceString = JSON.stringify(instance);
            for (var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++) {
                var key = _a[_i];
                var inputKey = "{" + keyPrefix + ":" + key + "}";
                var inputValue = inputs[key];
                instanceString = instanceString.split(inputKey).join(inputValue);
            }
            var response = JSON.parse(instanceString);
            return response;
        }
        catch (ex) {
            // If the conversions fail for any reason we can do a deep recursion
            // This can fail if the configuration for some reason has a circular dependency, of the
            // input value is invalid when replacing into the string
            console.warn('replaceInputs: string replacement failed, moving to recursive', ex);
        }
        var workingInstance = ksys_app_template_1.utils.object.deepMergeObjects({}, instance);
        for (var _b = 0, _c = Object.keys(inputs); _b < _c.length; _b++) {
            var key = _c[_b];
            var inputKey = "{" + keyPrefix + ":" + key + "}";
            var inputValue = inputs[key];
            ksys_app_template_1.utils.replaceTextRecursive(workingInstance, inputKey, inputValue);
        }
        return workingInstance;
    };
    return QueryContext;
}());
exports.QueryContext = QueryContext;
//# sourceMappingURL=QueryContext.js.map